/**
 * Human-readable labels for routes, used in breadcrumbs and navigation.
 *
 * doc 147 §5.2 (Phase 1 UI).
 */

import type { Route } from './hashRouter.js';

const ROUTE_LABELS: Record<Route['kind'], string> = {
  welcome: 'Welcome',
  entity: 'Entity Detail',
  domain: 'Domain',
  hub: 'Hub',
  feature: 'Feature',
  surface: 'Surface',
  'cloud-function': 'Cloud Function',
  'event-type': 'Event Type',
  constellation: 'Workspace',
  'relationship-map': 'Relationship Map',
  impact: 'Impact',
  trace: 'Trace',
  ask: 'AI Copilot',
  boards: 'Boards',
  diff: 'Diff',
  sandbox: 'Sandbox',
  review: 'Review',
  publish: 'Publish',
  lint: 'Linter',
  simulate: 'Simulation',
  compliance: 'Compliance',
  patterns: 'Read-Write Patterns',
  refactor: 'Refactor',
  behavioral: 'State Coverage Matrix',
  heatmap: 'Heatmap',
  storyboard: 'Journey Walkthrough',
  drift: 'Drift',
  testdata: 'Test Data',
  'compliance-hq': 'Compliance HQ',
  statemachine: 'State Machines',
  dashboard: 'Dashboard',
  'event-flow': 'Event Flow',
  'pii-tracer': 'PII Tracer',
  'live-monitor': 'Live Monitor',
  lineage: 'Data Lineage',
  settings: 'Settings',
  workspace: 'Workspace',
  'domain-map': 'Domain Map',
  'user-journeys': 'User Journeys',
  catalog: 'Catalog',
  'catalog-domain': 'Catalog Domain',
  'catalog-graph': 'Catalog Graph',
  'flag-catalog': 'Flag Catalog',
  'new-design-change': 'New Design Change',
  'firestore-path': 'Firestore Path',
};

/**
 * Get a human-readable label for a route.
 */
export function getRouteLabel(route: Route): string {
  return ROUTE_LABELS[route.kind] ?? route.kind;
}
